export default {
    namespaced: true, // Ensure namespacing is enabled
    state: {
      items: [],
    },
    getters: {
        // his getter returns an array of the products in the cart. 
        // It maps the cart items to product details (like id, title, price, quantity) 
        // by matching each id from the cart with the id from the products state in the root store.
      cartProducts: (state, getters, rootState) => {
        return state.items.map(({ id, quantity }) => {
          const product = rootState.products.all.find((product) => product.id === id);
          return {
            id: product.id,
            title: product.title,
            price: product.price,
            quantity,
          };
        });
      },
    //   This getter calculates the total price of all items in the cart by multiplying 
    // the price of each product by its quantity and summing the results.
      cartTotalPrice: (state, getters) => {
        return getters.cartProducts.reduce((total, product) => total + product.price * product.quantity, 0);
      },
    },

    actions: {
        // This action is used to add a product to the cart. It checks if the product has inventory available.
        // If the product isn't in the cart, it calls a mutation to add it to the cart.
        // If the product is already in the cart, it increments the quantity.
        // It also commits a mutation to decrement the inventory of the product in the root products store.
      addProductToCart({ state, commit }, product) {
        if (product.inventory > 0) {
          const cartItem = state.items.find((item) => item.id === product.id);
          if (!cartItem) {
            commit("pushProductToCart", { id: product.id });
          } else {
            commit("incrementItemQuantity", cartItem);
          }
          commit("products/decrementProductInventory", { id: product.id }, { root: true });
        }
      },
    },
    mutations: {
        // This mutation adds a new product to the items array in the cart with a quantity of 1.
      pushProductToCart(state, { id }) {
        state.items.push({ id, quantity: 1 });
      },
    //   This mutation increments the quantity of a specific item in the cart.
      incrementItemQuantity(state, { id }) {
        const cartItem = state.items.find((item) => item.id === id);
        if (cartItem) cartItem.quantity++;
      },
    },
  };
  